export const enum ModelRuleType {
  Domain = 'domain',
  Filtering = 'filtering',
  Dependencies = 'dependencies',
  SubVariants = 'subvariants',
  Properties = 'properties',
}
